export const getCurrentCompany = () => {
  return JSON.parse(localStorage.getItem("currentCompany"));
};

export const getApplicationCompanyId = () => {
  return localStorage.getItem("APPLICATION_COMPANY_ID");
};
